import React from "react"
import useFetch from "@yumgmbh/gatsby-theme-yum-components/src/hooks/useFetch"
import NewsCardsBlock from "../../@yumgmbh/gatsby-theme-yum-components/components/blocks/NewsCardsBlock"
import { useTranslation } from "react-i18next"

import { decode } from "html-entities"

const RelatedNewsBlock = ({ block }) => {
  const { t, i18n } = useTranslation()

  const urlEncodedCategories = (categories) => {
    let a = []
    categories.map((c) => {
      a.push(encodeURIComponent(c))
    })
    return a.join(",")
  }

  const {
    data: news,
    loading,
    error,
  } = useFetch(
    `${
      i18n.language === "de" ? process.env.NEWS_API : process.env.NEWS_EN_API
    }?any_categories=${urlEncodedCategories(block.categories)}&limit=${
      block.limit
    }`
  )

  const cardItems = news?.results.map((item) => {
    return {
      kicker: `${item.pub_date} - ${item.category}`,
      date: item.pub_date,
      category: item.category,
      image: { filename: item.image_url },
      link: item.link,
      headline: item.title,
      link_text: t("cards.read-more"),
      text: decode(item.description.replace(/<\/?[^>]+(>|$)/g, "")),
    }
  })

  return (
    <>
      {loading && <></>}
      {error && <></>}
      {!loading && (
        <>
          <NewsCardsBlock
            block={{
              _uid: block._uid,
              headline: block.title,
              show_slides: 4,
              view: "slider",
              card_items: cardItems,
            }}
          />
          {/* <EventCardsBlock
            block={{
              headline: block.title,
              show_slides: 5,
              view: "slider",
              card_items: cardItems,
            }}
          /> */}
        </>
      )}
    </>
  )
}

export default RelatedNewsBlock
